export default "__VITE_ASSET__88afc3bf__"